import React from "react";

//styles
import styles from "./ContentSlider.module.scss";
import cx from "classnames";

interface IContentSliderArrow {
    direction: "left" | "right";
    onClick: () => void;
    isDisabled?: boolean;
    isNavHidden?: boolean;
    className?: string;
}

const ContentSliderArrow: React.FC<IContentSliderArrow> = (props) => {
    const { direction, onClick, isDisabled, isNavHidden, className } = props;

    return React.useMemo(
        () => (
            <button
                className={cx([
                    styles["slider__nav"],
                    styles["slider__nav--container"],
                    {
                        [styles["slider__nav--left"]]: direction === "left",
                        [styles["slider__nav--right"]]: direction === "right",
                        [styles["nav-hidden"]]: isNavHidden,
                        [className]: !!className
                    }
                ])}
                onClick={onClick}
                disabled={isDisabled || undefined}
                type="button">
                <span
                    className={cx([
                        styles["slider__nav-icon"],
                        {
                            [styles["slider__nav-icon--left"]]: direction === "left",
                            [styles["slider__nav-icon--right"]]: direction === "right"
                        }
                    ])}></span>
            </button>
        ),
        [direction, onClick, className, isDisabled]
    );
};

export default ContentSliderArrow;
